import { useTranslation } from '@pancakeswap/localization'
import { Token } from '@pancakeswap/sdk'
import { Flex, FlexProps, Text } from '@pancakeswap/uikit'
import useSWR from 'swr'

import { arrayURLFetcher } from 'utils/legacy'
import { useConfig } from 'views/Predictions/context/ConfigProvider'

export const Row: React.FC<React.PropsWithChildren<FlexProps>> = ({ children, ...props }) => {
  return (
    <Flex alignItems="center" justifyContent="space-between" {...props}>
      {children}
    </Flex>
  )
}

interface NetWinningsProps extends FlexProps {
  amount: number
  textPrefix?: string
  textColor?: string
  fontWeight?: string
  fontSize?: string
  subFontSize?: string
  subFontWeight?: string
  subFontColor?: string
  color?: string
  hiddenTokenName?: boolean
}

export const NetWinnings: React.FC<React.PropsWithChildren<NetWinningsProps>> = (props) => {
  const { token } = useConfig()
  return <NetWinningsView token={token} {...props} />
}

export const NetWinningsView: React.FC<React.PropsWithChildren<NetWinningsProps & { token: Token }>> = ({
  token,
  amount,
  textPrefix = '',
  textColor = 'text',
  hiddenTokenName,
  ...props
}) => {
  const { data: tokenInfo } = useSWR('https://api.mummy.finance/api/tokens/info?symbols=FTM,MMY&chain=FANTOM', {
    fetcher: arrayURLFetcher,
  })

  const value = tokenInfo?.[0]?.FTM?.price * amount || 0
  // console.log('???value', value)

  if (!amount && amount !== 0) {
    return null
  }

  return (
    <Flex alignItems="flex-end" {...props} style={{ overflow: 'hidden' }}>
      <Text fontWeight={props.fontWeight || 'bold'} color={textColor} fontSize={props.fontSize || '14px'}>
        {/* {`${textPrefix}${amount.toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 6 })}`} */}
        {`${textPrefix}${Number(amount).toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`}{' '}
        {hiddenTokenName ? '' : 'FTM'}
      </Text>
      {value ? (
        <Text
          className="txt-dollar"
          fontSize={props.subFontSize || '14px'}
          color={props.subFontColor || 'white60'}
          // lineHeight={}
          fontWeight={props.subFontWeight || '400'}
          style={{ marginLeft: ' 4px' }}
        >
          {` $${Math.abs(value).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`}
        </Text>
      ) : (
        <Text
          className="txt-dollar"
          fontSize={props.subFontSize || '14px'}
          color={props.subFontColor || 'white60'}
          // lineHeight={}
          fontWeight={props.subFontWeight || '400'}
          style={{ marginLeft: ' 4px' }}
        >
          {' '}
          {amount === 0 ? '$0.00' : '$--'}
        </Text>
      )}
    </Flex>
  )
}

export const NetWinningsRow: React.FC<React.PropsWithChildren<{ amount: number }>> = ({ amount }) => {
  const { t } = useTranslation()
  const { token } = useConfig()
  return (
    <Row mb="8px" alignItems="flex-start">
      <Text fontSize="14px" color="white60">
        {/* {t('Net Winnings (%symbol%)', { symbol: token.symbol })} */}
        {t('PnL')}
      </Text>
      <NetWinnings
        subFontSize="12px"
        fontWeight="700"
        alignItems="center"
        // flexDirection="column"
        amount={amount}
        textPrefix={amount > 0 ? '+' : ''}
        textColor={amount > 0 ? 'success' : 'failure'}
      />
    </Row>
  )
}
